import {Button, Col, Form, Input, Row, Space, Typography} from "antd";
import {
  InputFields,
  ListActionButton,
  ModalCustom,
  Notification,
} from "components/common";
import Icon from "assets/icons";
import React, {useEffect, useRef, useState} from "react";
import {columns, fields} from "./config";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import ModalUser from "./ModalApi/ModalApi";
import {authenticationService} from "api";
import {checkTokenValidity} from "helper/auth";
import {tabKeys} from "types/enums";
import {useAppSelector} from "redux/hooks";
const Api = props => {
  const modalRef = useRef<any>();
  const childRef = useRef<any>();
  const [form] = Form.useForm();
  const [params, setParams] = useState({page: 1, limit: 10});
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [record, setRecord] = useState();
  const [data, setData] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const handlePaginationChange = (page, pageSize?: number) => {
    setParams({...params, page: page, limit: pageSize});
  };

  const paginationConfig = {
    total: total,
    onChange: handlePaginationChange,
  };
  useEffect(() => {
    const checkToken = () => {
      const valid = checkTokenValidity(localStorage.getItem("tokenAdmin"));
      if (valid) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    };
    if (activeTab == tabKeys.AUTHORIZATION.API) {
      checkToken();
    }
  }, [localStorage.getItem("tokenAdmin"), activeTab]);
  const getListApi = async () => {
    try {
      const res = await authenticationService.getListApi();
      setData(res);
    } catch (error) {}
  };
  const getListApiByName = async () => {
    try {
      const name = form.getFieldValue("name");
      const res = await authenticationService.getListApiByName(name);
      setData(res);
    } catch (error) {}
  };
  const onFinish = async values => {
    try {
      const res = await authenticationService.loginAdmin(values);
      if (res?.code == 200) {
        setIsAdmin(true);
        localStorage.setItem("tokenAdmin", res?.data?.accessToken);
      } else {
        throw {};
      }
    } catch (error) {
      Notification("error", "Đã có lỗi khi đăng nhập");
    }
  };
  useEffect(() => {
    if (isAdmin) {
      getListApi();
    }
  }, [isAdmin]);
  const onKeyDown = e => {
    if (e.key === "Enter") {
      getListApiByName();
    }
  };
  return (
    <>
      {isAdmin && (
        <>
          <div className="container" onKeyDown={onKeyDown} tabIndex={0}>
            <Form form={form} labelAlign="left">
              <Space direction="vertical" style={{width: "100%"}}>
                <Row gutter={[16, 8]}>
                  <InputFields data={fields} />
                  <Col>
                    <Button
                      type="primary"
                      icon={<Icon.search rev={0} />}
                      onClick={getListApiByName}
                    >
                      Tìm kiếm
                    </Button>
                  </Col>
                </Row>
              </Space>
            </Form>
          </div>
          <div className="container">
            <CustomResizableTable
              //   setShowColumns={setShowColumns}
              bordered
              dataSource={data}
              columns={columns}
              // className="custom-resize-table-scroll"
              // scroll={{x: 2500}}
              loading={loading}
              pagination={paginationConfig}
              onRow={record => ({
                onDoubleClick: () => {
                  modalRef?.current?.openModal();
                  setRecord(record);
                },
              })}
            />
          </div>
          <ModalCustom
            onOpenModal={() => {
              if (record == null) {
                childRef?.current?.resetFields();
              }
            }}
            draggable
            width={1400}
            ref={modalRef}
            title={`${record ? "Sửa" : "Thêm"} thông tin API`}
          >
            <ModalUser
              ref={childRef}
              record={record}
              getListApi={getListApi}
            ></ModalUser>
          </ModalCustom>
        </>
      )}
      {!isAdmin && (
        <div
          className="container"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Form
            style={{width: 600}}
            form={form}
            // layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
          >
            <Space direction="vertical" style={{width: "100%"}}>
              <Row justify={"center"}>
                <Typography.Text className="login-description" type="secondary">
                  Đăng nhập để sử dụng chức năng này
                </Typography.Text>
              </Row>
              <Form.Item
                name="username"
                rules={[
                  {required: true, message: "Vui lòng nhập tên đăng nhập!"},
                ]}
              >
                <Input placeholder="Tên đăng nhập" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{required: true, message: "Vui lòng nhập mật khẩu!"}]}
              >
                <Input.Password placeholder="Mật khẩu" />
              </Form.Item>

              <Row justify={"center"}>
                <Button
                  type="primary"
                  className="login-btn btn-sub"
                  htmlType="submit"
                >
                  Đăng nhập
                </Button>
              </Row>
            </Space>
          </Form>
        </div>
      )}
    </>
  );
};
export default Api;
